import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-medical',
  templateUrl: './main-medical.component.html',
  styleUrls: ['./main-medical.component.css']
})
export class MainMedicalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
